import React from 'react';
import styled from 'styled-components';
import { theme } from '../../../theme';
import { Heading } from '../../typography';
import { CompactCard, CompactCardProps } from './CompactCard';

export type ActionCompactCardProps = CompactCardProps & {
  price: string;
  subContent: React.ReactNode;
  buttonContent: React.ReactNode;
  lotSku?: string;
};

const Price = styled(Heading).attrs({ size: 6 })`
  color: ${theme.colors.primary.graysRed};
`;

const RightContainerLowerLeft = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

const RightContainerLowerRight = styled.div``;

export const ActionCompactCard: React.FC<ActionCompactCardProps> = ({
  price,
  subContent,
  buttonContent,
  ...props
}) => (
  <CompactCard {...props}>
    <RightContainerLowerLeft>
      <Price>{price}</Price>
      {subContent && <div>{subContent}</div>}
    </RightContainerLowerLeft>
    <RightContainerLowerRight>{buttonContent}</RightContainerLowerRight>
  </CompactCard>
);
